const SESSION_EXPIRED_ERROR_CODE = "session_expired";
const SERVICE_ACCESS_REQUIRED_ERROR_CODE = "service_access_required";
export {
  SERVICE_ACCESS_REQUIRED_ERROR_CODE,
  SESSION_EXPIRED_ERROR_CODE
};
//# sourceMappingURL=user.js.map
